module.exports = __webpack_public_path__ + "img/pc2.4046a177.png";